import { enqueueSnackbar } from "notistack";
import { CurrentReservation, PubTournament } from "../../../../api/types";
import { isRunner } from "../../../../utils/common";
import { usePubContext } from "./pub-context";
import { useHistory } from "react-router-dom";
import { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { userState } from "../../../../recoil/auth";

export const usePubTournament = (item: PubTournament) => {
  const { data, setIsReservationCancel, setReservationCancelItem } =
    usePubContext();
  const history = useHistory();
  const user = useRecoilValue(userState);
  const [isReservation, setIsReservation] = useState<boolean>(false); // 해당 토너먼트 예약 여부
  const [isSpecial, setIsSpecial] = useState<boolean>(false); // 특별초대권 예약 여부
  const [userReservation, setUserReservation] =
    useState<CurrentReservation | null>(null); // 해당 토너먼트 예약 dto

  useEffect(() => {
    // 토너먼트 예약자 현황에서 현재 유저 정보 찾기
    if (item.current && user) {
      const userReservation = item.current.find(
        (current) => current.userId === user.id
      );
      if (userReservation) {
        setIsReservation(true);
        setIsSpecial(userReservation.route === "SPECIAL");
        setUserReservation(userReservation);
      } else {
        setIsReservation(false);
        setIsSpecial(false);
        setUserReservation(null);
      }
    }
  }, [item]);

  // 예약 가능 조건
  const canReservation = (): boolean => {
    if (!item.reservation) {
      return false;
    }

    // 현재 레벨 존재할 경우
    const currentLevel = item.timeInfo.currentLevel.level;
    if (currentLevel) {
      if (item.registerDeadlineLevel >= currentLevel) {
        return true;
      }
    } else {
      // break일 경우
      const level = item.timeInfo.nextLevel?.level - 1;
      if (item.registerDeadlineLevel >= level) {
        return true;
      }
    }

    return false;
  };

  // 하단 버튼 텍스트
  const getReservationButtonText = (): string => {
    // 예약이 있는 경우
    if (item.reservation) {
      if (isReservation) {
        return "예약취소";
      }
      if (!canReservation()) {
        return "레지마감";
      }
      return `예약하기`;
    }
    // 예약이 없고 토너먼트가 시작 되었을 떄
    if (!item.isEnd && item.timeInfo.elapsedTimeMs > 0) {
      return `토너먼트 진행 현황`;
    }
    return "시작 준비 중";
  };

  // 하단 좌측 버튼 클릭 이벤트
  const handleClickStateButton = () => {
    // 예약 가능하고 레지 마감 전전
    if (item.reservation && !item.isEnd && item.timeInfo.elapsedTimeMs < 0) {
      if (isRunner(data?.pubType)) {
        history.push(`/company-reservation/${item.reservation!.id}`);
        return;
      } else {
        history.push(`/reservation/${item.reservation!.id}`);
        return;
      }
    }
    // 토너먼트 진행현황 페이지
    history.push(`/tournament/${item.id}`);
  };

  // 하단 버튼 클릭 이벤트
  const handleClickButton = () => {
    // 예약이 없을 경우 토너먼트 진행현황 페이지
    if (!item.reservation) {
      history.push(`/tournament/${item.id}`);
      return;
    }
    // 유저가 예약했을 경우 -> 예약 취소 로직
    if (isReservation && userReservation) {
      // 특별초대권은 취소 불가
      if (isSpecial) {
        enqueueSnackbar(
          "특별초대권으로 예약된 토너먼트는 취소할 수 없습니다. ",
          { variant: "error" }
        );
        return;
      }
      // 예약취소
      setReservationCancelItem(userReservation);
      setIsReservationCancel(true);
      return;
    }
    
    if (canReservation()) {
      if (isRunner(data?.pubType)) {
        history.push(`/company-reservation/${item.reservation!.id}`);
      } else {
        history.push(`/reservation/${item.reservation!.id}`);
      }
    }
  };

  return {
    // 텍스트
    getReservationButtonText,
    // 클릭 이벤트
    handleClickStateButton,
    handleClickButton,
    // 예약 가능 여부
    canReservation,
    // 유저 예약 여부
    isReservation,
  };
};
